module.exports = __webpack_public_path__ + "static/media/GreatRoom1.ce2fd410.jpg";